import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "pie-chart-1, graph, chart, statistics" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M10.0013 2.29297C5.74411 2.29297 2.29297 5.74411 2.29297 10.0013C2.29297 14.2585 5.74411 17.7096 10.0013 17.7096C13.3576 17.7096 16.2128 15.5646 17.271 12.5707M10.0013 2.29297C14.2585 2.29297 17.7096 5.74411 17.7096 10.0013C17.7096 10.9022 17.5551 11.7671 17.271 12.5707M10.0013 2.29297V10.0013L17.271 12.5707",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }